// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3AGub","item":"PaymentsMobile_item__25Xff","label":"PaymentsMobile_label__V04gZ","amount":"PaymentsMobile_amount__3fq_b"};